<template>
  <div id="app">

    <div id='cart-overlay' :class="[{'open': overlayActive}, overlayColor]"></div>

    <div id="cart-main">

      <div id="notifications">
        <div class="notif-item" v-bind:class="notif.type" v-for="(notif, index) in this.app.notif.data" :key="index" >
          {{notif.message}}
        </div>
      </div>

      <router-view/>

    </div>

    <modal v-if="app.dialog.visible" v-on:close="closeModelDetail()" :size="'D'">
      <div slot="header">
      </div>

      <div slot="body">
        <div id="dialog-message">
          {{app.dialog.message}}
        </div>
      </div>

      <div slot="footer">
        <a href="javascript:" class="button" v-for="button in app.dialog.buttons" v-bind:class="{'primary' : button.primary}" @click="app.dialog.execute(button)">{{button.text}}</a>
      </div>
    </modal>

    <div id="work-in-progress" v-if="this.app.notif.wip.showing">
      <div id="work-in-progress-spacer">&nbsp;</div>
      Working, please wait...<br />
      {{this.app.notif.wip.message}}
    </div>

  </div>
</template>

<script>
import notification from './notification';
import Dialog from './dialog'
import Utils from '@/utils'
import Order from '@/order'
import Cart from '@/cart'
import {Intercom} from '@/service/intercom'

import Modal from './components/ModalPanel'

export default {
  components: {
    Modal
  },
  data () {
    return {
      app : {
        notif: notification,
        dialog: Dialog
      },
      Order: Order,
      cartGlobals: Cart.globals,
      overlayActive: null,
      overlayColor: 'light' // light (while processing) | dark (while 3D secure)
    };
  },
  watch: {
    cartGlobals: {
      deep: true,
      handler() {
        console.log('WATCH: cartGlobals', this.cartGlobals.overlayActive)
        this.overlayActive = this.cartGlobals.overlayActive
        this.overlayColor = this.cartGlobals.overlayColor
      }
    }
  },
  created() {
    // reset
    // This cookie is required for proper shoping the login form... no idea now, why it was here.
    // Making just a comment for possible another need to repeat this mistake.
    // Utils.removeCookie('nur')
  },
  mounted() {
    
    // console.log('intercom: booting')
    // this.$intercom.boot()
    // Intercom.getVisitorId()
  
  },
}

</script>

<style lang='less'>
@import 'variables.less';
@import 'fonts/fonts.less';

:root {
    --window-inner-height: 0;
}

html {
  background-color: @pfm-cart-bg;
  color: @pfm-cart-text-body;
  height: 100%;
  box-sizing: border-box;
  font-family: 'MarkPro';
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.05rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
    margin: 0;
    position: relative;
    /* padding-bottom: 6rem; */
    height: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-weight: bold;
    padding: 0;
    margin: 0;
}

h2 {
  font-size: 2.2rem;
  color: @pfm-cart-text-h2;
  letter-spacing: 0.1rem;
  font-weight: 400;
}

h3 {
  font-size: 1.375rem;
  color: @pfm-cart-text-h3;
  letter-spacing: 0.0375rem;
  font-weight: 400;
  padding-bottom: 8px;
}

p {
    padding: 0;
    margin: 0;
}

a {
    text-decoration: none;
}

ul {
    list-style-type: none;
    padding: 0;
}

:focus {
    outline: 0;
}

.nowrap {
  white-space: nowrap;
}

// Global animations

// rotating - used when loading
@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes slideInFromTop {
    0% {
        margin-top: -100px;
    }
    100% {
        margin-top: 0;
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

@keyframes shake {
    10%,
    90% {
        transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
        transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
        transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
        transform: translate3d(4px, 0, 0);
    }
}

.shake {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
}


#app {
  -webkit-tap-highlight-color: rgba(0,0,0,0); // remove grey highlight box on tap in iOS Safari
  height: 100%;
  min-width: 320px;

  &::-webkit-scrollbar {
      width: 0;
      background: transparent;
  }

  a {
      color: #2A313C;
  }

  // buttons
  a.pfm-button {
      width: 100%;
      // max-width: 335px;
      margin: 0 auto;
      border-radius: 8px;
      background-color: @pfm-button-primary-background;
      color: @pfm-button-primary-color;
      padding: 19px 25px 19px 25px;
      font-size: 0.875rem;
      letter-spacing: 0.15rem;
      text-transform: uppercase;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      text-align: center;
      cursor: pointer;
      transition: background-color 0.5s;

      &.icononly {
          align-items: center;
          padding: 9px 0 9px 0;

          svg {
            width: 34px;
            height: 34px;

            & * {
                //stroke: #2A313C;
                fill: @pfm-button-primary-icon;
            }
          }
      }

      &.loading,
      &.working {
          padding-top: 16px;
          padding-bottom: 16px;
          background-color: @pfm-button-primary-background-hover !important; // important to disable hover
          cursor: wait;


          .animation-wrap.loading {
            display: flex;

              svg {
                  animation: spin 1s linear infinite;
                  width: 24px;
                  height: 24px;
              }
          }
      }

      &.done,
      &.success {
        padding-top: 11px;
        padding-bottom: 11px;

        .icon-wrap.done {
          display: flex;

          svg {
            width: 34px;
            height: 34px;
          }
        }
      }

      &.success {
        background-color: @pfm-cart-color-success !important;
      }

      &.failed {
        background-color: @pfm-cart-color-danger;
      }

      &:hover {
        background-color: @pfm-button-primary-background-hover;
        transition: background-color 0.5s;
      }

      &.failed {
        &:hover {
          background-color: @pfm-cart-color-danger;
        }
      }

      &:active {
        background-color: @pfm-button-primary-background;
        transition: background-color 0.5s;
      }

      &.light {
          background: @pfm-button-light-background;
          color: @pfm-button-light-color;

          svg {
              & * {
                  //stroke: #2A313C;
                  fill: @pfm-button-light-icon;
              }
          }
      }

      &.danger {
          background: @pfm-cart-color-danger;
      }

      &.icon {
          // display: flex;
          // flex-direction: row;
          // justify-content: center;
          align-items: center;
          padding: 18px 25px;

          svg {
            width: 20px;
            height: 20px;

            & * {
                //stroke: #2A313C;
                fill: @pfm-button-primary-icon;
            }
          }
      }

      svg {
          height: 20px;
          width: auto;

          & * {
              fill: #ffffff;
          }
      }

      span {
          padding-left: 6px;
          // display: block;
      }

      &.secondary {
          background: none;
          border: 2px solid #2A313C;
          color: @pfm-button-secondary-color;
      }

      &.tertriary {
          background: none;
          border: none;
          font-size: 0.8rem;
          color: @pfm-button-tertriary-color;
      }

      &.inline {
        background: none;
        border: none;
        padding-left: 0;
        padding-right: 0;
        margin: 0;
        letter-spacing: 0.05rem;
        max-width: none;
        width: auto;

        &.center {
          justify-content: center;
        }

        &.left {
          justify-content: left;
        }

        &.icon {
          svg {
            & * {
                //stroke: #2A313C;
                fill: @pfm-button-tertriary-color;
            }
          }
        }

        span {
          color: @pfm-button-tertriary-color;
          text-transform: none;
          font-size: 1rem;
          text-align: left;
        }

        &.danger {

          span {
            color: @pfm-cart-color-danger;
          }

          svg {
            & * {
                //stroke: #2A313C;
                fill: @pfm-cart-color-danger;
            }
          }
        }
      }
  }

  // forms
  .pfm-switch {
    width: 100%;
    // padding: 20px;
    background-color: @pfm-cart-color-form-switch-bg;
    border-radius: 7px;
    margin: 5px 0 5px 0;
    cursor: pointer;
    overflow: hidden;


    .header {
      height: 56px;
      padding: 0 20px 0 20px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      // align-items: center;
    }

    &:hover {
      background-color: @pfm-cart-color-form-switch-bg-hover;
    }

    &.selected {
      background-color: @pfm-cart-color-form-switch-bg-selected;
      height: auto;
      .header {
        height: 56px;
      }

      label.radio-label {
        color: @pfm-cart-color-form-switch-text-selected;
      }

      .radio-wrap {
        .module-price {
          color: @pfm-cart-color-form-switch-text-selected;
        }
      }
    }

    &.disabled {
      background-color: @pfm-cart-color-form-switch-background-disabled;
      cursor: not-allowed;

      label.radio-label {
        color: @pfm-cart-color-form-switch-text-disabled;
      }

      .radio-wrap {
        .module-price {
          color: @pfm-cart-color-form-switch-text-disabled;
        }
      }
    }

    input {
      display: none;
    }

    label.radio-label {
      font-size: 1rem;
      font-weight: 400;
      color: @pfm-cart-color-form-switch-text;
      pointer-events: none;
    }

    .radio-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .multiple-lines {
        .delivery-place {
          font-size: 0.75rem;
          display: block;
          color: @pfm-cart-color-form-switch-text-secondary;
          letter-spacing: 0;
        }
      }
      .module-price {
        font-weight: 500;
        color: @pfm-cart-color-form-switch-text;
      }
    }
  }

  .pfm-checkbox {
    margin: 10px 0 10px 0;

      .box-label-wrap {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          &:hover {
            .box {
              box-shadow: 0 0 0 1px @pfm-cart-color-border;
              cursor: pointer;
            }
          }

          .box {
              width: 32px;
              height: 32px;
              border-radius: 7px;
              border: 1px solid @pfm-cart-color-border;
              display: flex;
              justify-content: center;
              align-items: center;
              transition: all 0.2s ease-in-out;

              svg.icon-tick {
                  width: 100%;
                  height: 100%;
                  display: none;
              }




          }

          input {
              display: none;
          }

          label {
              padding-left: 10px;
              height: 100%;
              display: block;
          }
      }

      &.checked {
        .box-label-wrap {

          &:hover {
            .box {
              box-shadow: none;
              // background-color: @pfm-cart-color-form-switch-bg-hover;
            }
          }
          .box {
            background-color: @pfm-cart-color-form-switch-bg-selected;
            border-color: @pfm-cart-color-form-switch-bg-selected;
            transition: all 0.2s ease-in-out;

            svg.icon-tick {
                display: block;
                & * {
                    fill: #fff;
                }
            }
          }
        }

      }
  }

  // misc
  .highlight {
    &.total-price {
      background-color: @pfm-cart-total-price-bg;
      height: 60px;
      padding: 0 30px 0 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 30px;

      span {
        font-weight: bold;
      }
    }
  }

  // layout
  #cart-overlay {
    display: block;
    pointer-events: none;
    opacity: 0;
    transition: 0.5s ease-in-out;

    &.open {
      opacity: 1;
      pointer-events: all;
      position: fixed;
      // position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1000;

      &.light {
        background: rgba(255,255,255,0.75);
      }

      &.dark {
        background: rgba(0,0,0,0.9);
      }
    }
  }

  #cart-main {
    width: calc(100% - 40px);
    margin: 0 auto;
    padding-top: 100px;

    #window-panel {
      background-color: @pfm-cart-bg;
    }
  }

}

// google maps autocomplete
.pac-container {
  width: calc(100% - 40px) !important;
  border-radius: 7px;
  overflow: hidden;
  box-shadow: 2px 2px 18px 0px rgba(0,0,0,.2);
  border: none;
  margin-top: 6px;
  left: 20px !important;


  &.pac-logo {
    &:after {
      // background-image: none !important;
      // height: 0px;
      background-position: center 10px;
      background-size: 84px 10px;
      height: 26px;
    }

    .pac-item {
      font-family: 'MarkPro';
      font-weight: normal !important;
      font-size: 0.8rem;
      letter-spacing: 0.05rem;
      padding: 10px 20px;
      color: @pfm-color-neutral-500 !important;

      &:first-child {
        border-top: none;
      }

      .pac-icon {
        display: none;
      }
      .pac-item-query {
        color: @pfm-cart-color-form-text !important;
        font-size: 0.9375rem !important;
        letter-spacing: 0.05rem !important;

        .pac-matched {
          font-weight: bold !important;
        }
      }
    }
  }
}
</style>
